import {VOLUME_CHANGE} from '../actions/volume';

export default(state = {
    volume: 0.8
}, action) => {
    switch (action.type) {
        case VOLUME_CHANGE:
            return {
                volume: parseFloat(action.value)
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/settings.js